import { configRefs } from '@utils/constants';
import { componentDisplayDataSchema } from './schema.component-display-data.js';
import { authenticateComponentFrameworkRequest } from './util.authenticate-component-framework-request.js';

async function fetchComponentDisplayData(referenceId) {
  const res = await new Promise(resolve => {
    pendingResponses[referenceId] ??= new Set();
    pendingResponses[referenceId].add(resolve);
    fetchPending();
  });
  if (!res.ok) {
    throw new Error("fetchComponentDisplayData(): unable to resolve display data");
  }
  return componentDisplayDataSchema.parse(res.content);
}
let pendingResponses = {};

/**
 * The ComponentFramwork API allows for fetching entries for several components
 * at once, however DX prefers being able to request a single component per
 * call. Thus we use this method to batch several calls to limit requests to
 * the backend.
 */
const fetchPending = async () => {
  const pendingResponsesForCurrentCall = Object.fromEntries(Object.keys(pendingResponses).map(key => [key, new Set(pendingResponses[key])]));
  const referenceIdList = Object.keys(pendingResponsesForCurrentCall).toSorted((a, b) => a.localeCompare(b));
  pendingResponses = {};
  const url = `${await configRefs.apis.componentFramework.get()}/api/References/GetDisplayInfoList?referenceIDs=${encodeURIComponent(referenceIdList.join(","))}`;
  const res = await fetch(...authenticateComponentFrameworkRequest(url));
  const errorText = await (async () => {
    if (res.status < 200 || res.status >= 300) {
      return await res.text();
    } else {
      return undefined;
    }
  })();
  const groupedData = await (async () => {
    if (!res.ok) {
      return;
    }
    return await res.json();
  })();
  for (const [referenceID, pendingResponseSet] of Object.entries(pendingResponsesForCurrentCall)) {
    for (const pendingResponse of pendingResponseSet) {
      if (!res.ok) {
        pendingResponse({
          ok: false,
          status: res.status,
          error: errorText
        });
        continue;
      }
      const index = referenceIdList.indexOf(referenceID);
      pendingResponse({
        ok: true,
        content: groupedData?.[index]
      });
    }
  }
};

export { fetchComponentDisplayData };
//# sourceMappingURL=request.fetch-component-display-data.js.map
